<template lang="pug">
div
  slide-show
  products
  about
  shops
</template>

<script>
import SlideShow from "./SlideShow";
import Products from "./Products";
import About from "./About";
import Shops from "./Shops";

export default {
  components: {
    SlideShow,
    Products,
    About,
    Shops,
  },
};
</script>

<style>
</style>
